(ns manage.ad-variant-preview.widgets.preview-item
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["react-use/lib/useEvent$default" :as useEvent]
            ["src/svg/controls/media_player_call/volume-slash.svg$default" :as VolumeSlash]
            ["src/svg/controls/media_player_call/volume-wave-2.svg$default" :as Volume]
            ["src/svg/inform/bubble-left-text.svg$default" :as BubbleLeftText]
            ["src/svg/inform/error-diamond-fill.svg$default" :as ErrorIcon]
            ["src/svg/wpp/content/cart.svg$default" :as Cart]
            [common.flags :refer [use-flag]]
            [common.queries :refer [use-mutation]]
            [common.widgets.iframe.view :as iframe]
            [common.widgets.truncated :as truncated]
            [manage.ad-variant-preview.data :as data]
            [manage.ad-variant-preview.db :as db]
            [manage.ad-variant-preview.hooks :as hooks]
            [manage.ad-variant-preview.meta :refer [carousel meta-wrapper]]
            [manage.ad-variant-preview.tiktok :refer [tiktok-wrapper]]
            [manage.ad-variant-preview.viewport :as viewport]
            [manage.ad-variant-preview.widgets.component-error :refer [component-error]]
            [manage.ad-variant-preview.widgets.image-preview :as image-preview]
            [manage.ad-variant-preview.widgets.video-preview :as video-preview]
            [manage.ad-variant.data :as variant-data]
            [manage.ad-variant.queries :as q]
            [manage.ad-variant.widgets :as variant-widgets]
            [manage.variants-preview-panel.view.core :refer [preview-display-tag]]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- trigger-comment-to-variant [{:keys [has-video video-status-ref ad-variant-uuid identifier]}]
  (let [;; Has-video says if THIS ad-variant is a video.
        ;; Get the same video el the bottom panel is using for duration,
        ;; and get the timestamp at the moment of button click.
        ;; This isn't necessarily the exact same ad-variant video el, but
        ;; we have a global video seeking so this makes sense.
        {{video-el :el} :video} (when has-video
                                  (data/find-longest-video (.-current video-status-ref)))
        current-video-timestamp (when video-el
                                  (.-currentTime video-el))]
    (rf/dispatch [::db/set-new-comment-info {:props (cond-> {:comment/subject-type "ad-variant"
                                                             :comment/subject-id ad-variant-uuid}
                                                      current-video-timestamp (assoc :comment/meta {:timestamp current-video-timestamp}))
                                             :info {:ad-variant-label identifier}}])
    (rf/dispatch [:ocp/open {:id :comments/ocp
                             :props {:comment-mode? true
                                     :ad-variant-uuid ad-variant-uuid}}])))

(defui preview-wrapper [{:keys [width variant children]}]
  (let [{:keys [ad-type components]} variant]
    (cond
      (variant-data/meta? ad-type)
      ($ meta-wrapper
         {:width width
          :components components
          :carousel? (= "meta-carousel" ad-type)}
         children)

      (variant-data/tiktok? ad-type)
      ($ tiktok-wrapper
         {:width width
          :components components}
         children)
      :else
      children)))

(defui preview-error-tooltip [{:keys [error children]}]
  (if error
    ($ Tooltip
       {:color "error"
        :placement "top"
        :title ($ Stack
                  {:direction "row"
                   :alignItems "center"
                   :gap 0.5}
                  ($ SvgIcon {:color "error"}
                     ($ ErrorIcon))
                  ($ Stack
                     {:component "ul"
                      :gap 0.5
                      :sx #js {:m 0
                               :pl 2}}
                     (for [[index m] (mc/seq-indexed (:message error))]
                       ($ :li {:key index} m))))}
       ($ :div children))
    children))

(defui template-preview-iframe
  [{:keys [width height component variant]}]
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        auth-token (use-subscribe [:resource.user/token])
        load-content-within-the-tag? (use-flag :preview-tag-content-loading)
        {:keys [event-target item-scale product-overrides-ref
                share-token shared-advertiser-id shared-product-overrides]} (viewport/use-context)

        ;; when on share page values from share link metadata should be used.
        advertiser-id (or advertiser-id shared-advertiser-id)
        auth-token (or auth-token share-token)

        {:keys [value error]} component
        {:keys [template content]} value
        product-overrides (if product-overrides-ref @product-overrides-ref [])
        product-overrides (or product-overrides shared-product-overrides)

        ;; Build previewPassthrough from product overrides and variant UUID
        product-selector-id (variant-data/get-product-selector-id variant)

        {:keys [preview-passthrough]}
        (hooks/use-product-overrides {:variant variant
                                      :advertiser-id advertiser-id
                                      :product-overrides product-overrides
                                      :shared-product-overrides shared-product-overrides
                                      :product-selector-id product-selector-id})

        iframe-ref (uix/use-ref nil)]
    (useEvent "reload-display"
              (fn [_e]
                (iframe/reload @iframe-ref))
              event-target)
    (if error
      ($ component-error
         {:width width
          :height height})
      ($ preview-display-tag
         (merge {:iframe-ref iframe-ref
                 :advertiser-id advertiser-id
                 :adset-id adset-id
                 :width width
                 :height height
                 :scale item-scale}
                (if load-content-within-the-tag?
                  {:preview-passthrough preview-passthrough
                   :preview-token auth-token}
                  {:content content
                   :template template}))))))

(defui add-review-comment [{:keys [has-video identifier ad-variant-uuid]}]
  (let [{:keys [video-status-ref]} (viewport/use-context)]
    ($ Tooltip
       {:title "Comment this variant"
        :placement "bottom"}
       ($ IconButton
          {:size "small"
           :onClick (fn [e]
                      (trigger-comment-to-variant {:has-video has-video
                                                   :video-status-ref video-status-ref
                                                   :ad-variant-uuid ad-variant-uuid
                                                   :identifier identifier})
                      (.preventDefault e)
                      (.stopPropagation e))
           :sx #js []}
          ($ BubbleLeftText)))))

(defui preview-content [{:keys [variant set-video-status video-controls
                                on-current-card-video-change carousel-controls]}]
  (let [{:keys [components ad-type dimensions]} variant
        component-type (variant-data/get-component-type ad-type)
        main-component (variant-data/get-main-component components ad-type)
        set-video-status (uix/use-callback (fn set-video-status-callback [f & args]
                                             (if (nil? f)
                                               (set-video-status #(dissoc % uuid))
                                               (set-video-status #(apply update % uuid f args))))
                                           ;; set-video-status is stable state hook updater
                                           ^:lint/disable
                                           [uuid])

        {:keys [item-scale]} (viewport/use-context)
        [width height] (data/get-card-dimensions
                        {:ad-type ad-type
                         :component main-component
                         :template-dimensions dimensions
                         ;; HTML ads are previewed inside an iframe with a fixed width,
                         ;; which prevents them from being scaled by changing their dimensions.
                         ;; That's why item-scale is not applied here in this case.
                         ;;
                         ;; To enable scaling HTML ads, the `item-scale` is applied using
                         ;; the `zoom` CSS property in `common.display-tag/display-tag`.
                         :item-scale (when (or (not= component-type :html)
                                               ;; The error component can be scaled normally however.
                                               (:error main-component))
                                       item-scale)})]
    ($ preview-wrapper {:width width :variant variant}
       (case component-type
         :html ($ template-preview-iframe
                  {:width width
                   :height height
                   :component main-component
                   :variant variant})

         :video ($ video-preview/video-preview
                   {:width width
                    :height height
                    :variant variant
                    :component main-component
                    :set-video-status set-video-status
                    :video-controls video-controls})

         :image ($ image-preview/image-preview
                   {:width width
                    :height height
                    :component main-component})

         :carousel ($ carousel
                      {:width width
                       :component main-component
                       :set-video-status set-video-status
                       :video-controls video-controls
                       :on-current-card-video-change on-current-card-video-change
                       :carousel-controls carousel-controls})
         nil))))

(defui ^:memo preview-item [{:keys [set-item-places variant set-video-status video-controls review _focused product-overrides]}]
  (let [{:keys [set-video-controls accessed-via-share-link video-status-ref
                on-product-selected]} (viewport/use-context)
        {:keys [uuid ad-type ad-formats ad-variant-status] identifier :content-id} variant
        allow-product-overrides? (use-flag :preview-product-overrides)
        dynamic-content (uix/use-memo (fn []
                                        (some :dynamic-content ad-formats))
                                      [ad-formats])
        has-product-placeholders? (uix/use-memo
                                   (fn []
                                     (some (fn [[_ {:keys [source-type]}]]
                                             (= source-type "products"))
                                           dynamic-content))
                                   [dynamic-content])
        item-ref (uix/use-ref nil)
        preview-item-measure (viewport/use-measure-preview-item set-item-places uuid)

        [identifier-overflowing identifier-overflowing-ref] (truncated/use-overflowing)

        {:keys [audio-active-variant]} video-controls
        audio-active (= uuid audio-active-variant)
        has-video (= :video (variant-data/get-component-type ad-type))

        create-lift-feature? (use-flag :create-lift-preview)
        create-lift-data (uix/use-memo (fn []
                                         (variant-data/get-create-lift-data variant))
                                       [variant])

        {:keys [score-available score]} (uix/use-memo (fn []
                                                        {:score-available (= "done" (:state create-lift-data))
                                                         :score (:score (:data create-lift-data))})
                                                      [create-lift-data])
        show-create-lift? (and (not accessed-via-share-link)
                               create-lift-feature?
                               score-available)

        me (use-subscribe [:resource.user/me])
        review-mode? (:review (use-subscribe [:router/query-parameters]))
        user-is-reviewer (and review-mode?
                              (seq (filter #(= (:id me) (:user-request-mapping/user-id %)) (:user-mappings review))))
        user-is-review-creator (= (:id me) (:request/created-by review))
        request-id (:request/id review)
        {:keys [adset-id]} (use-subscribe [:url-context])
        {set-qc-approval :mutate} (use-mutation (q/assign-status {:request-id request-id
                                                                  :adset-id adset-id}))
        variant-qc-status (->> review
                               :user-mappings
                               (filter #(= (:user-request-mapping/user-id %) (:id me)))
                               first
                               :statuses
                               (filter #(= (:status/subject-id %) uuid))
                               first
                               :status/status)

        product-selector-id (variant-data/get-product-selector-id variant)
        error (hooks/use-variant-error variant)]

    ;; On unmount cleanup the measurement.
    (uix/use-effect (fn []
                      (fn []
                        (preview-item-measure nil)))
                    [preview-item-measure])

    ;; Trigger measurement on any render.
    ;; Probably simplest this way. Because the component isn't memoized, all selection
    ;; changes trigger all preview-item renders.
    ;; All changes to select-items before this in row/cols can effect measurements of this item.
    (uix/use-effect (fn []
                      (preview-item-measure @item-ref)))
    ($ Paper
       {:component Stack
        :ref item-ref
        :sx #js {:position "relative"
                 :height "fit-content"
                 :overflow "hidden"}}
       ($ preview-content
          {:variant variant
           :set-video-status set-video-status
           :video-controls video-controls})
       ($ Stack
          {:gap 1
           :sx #js {:padding 2}}
          ($ Stack
             {:direction "row"
              :justifyContent "space-between"
              :alignItems "center"}
             ($ Stack {:direction "row" :gap 1}
                ($ preview-error-tooltip {:error error}
                   ($ :div
                      ($ variant-widgets/status-chip
                         {:status (if (and user-is-reviewer (not user-is-review-creator) (not accessed-via-share-link))
                                    (or variant-qc-status "internal-review")
                                    ad-variant-status)
                          :review? user-is-reviewer})))
                (when show-create-lift?
                  ($ Tooltip
                     {:title "Create lift score"
                      :placement "top"}
                     ($ :div
                        ($ variant-widgets/predictive-score-chip
                           {:score score})))))

             ($ Stack
                {:direction "row"
                 :justifyContent "space-between"
                 :alignItems "center"
                 :gap 2}
                (when (some? (get product-overrides product-selector-id))
                  ($ Tooltip
                     {:title "Updated because the shared product selection changed."
                      :placement "top"
                      :slotProps #js {:tooltip #js {:sx #js {:maxWidth "none"
                                                             :whiteSpace "nowrap"}}}}
                     ($ :div
                        ($ Chip
                           {:label "Preview updated"}))))
                (when has-video
                  ($ Tooltip
                     {:title (if audio-active
                               "Mute this variant"
                               "Unmute this variant")
                      :placement "bottom"}
                     ($ IconButton
                        {:size "small"
                         :onClick (fn [e]
                                    (set-video-controls (if audio-active
                                                          #(assoc % :audio-active-variant nil)
                                                          #(assoc % :audio-active-variant uuid)))
                                    (.preventDefault e)
                                    (.stopPropagation e))
                         :sx #js [(when audio-active
                                    #js {:color "primary.500"
                                         :backgroundColor "primary.100"})]}
                        ($ (if audio-active
                             Volume
                             VolumeSlash)))))

                (when (and (or user-is-reviewer user-is-review-creator)
                           (not accessed-via-share-link))
                  ($ add-review-comment
                     {:has-video has-video
                      :identifier identifier
                      :ad-variant-uuid uuid}))))
          ($ Stack
             {:direction "row"
              :justifyContent "space-between"
              :alignItems "center"}
             ;; Use absolute positioning for the content-id row, because
             ;; the text needs to use textOverflow so we need to set the width
             ;; statically using parent width and without the content of this div
             ;; affecting parent width.
             ($ Box
                {:sx #js {:position "relative"
                          :width "100%"}}
                ($ Stack
                   {:direction "row"
                    ;; Match line height
                    :sx #js {:height "1.5em"}})
                ($ Stack
                   {:direction "row"
                    :sx #js {:overflow "hidden"
                             :position "absolute"
                             :top 0
                             :left 0
                             :width "100%"}}
                   ($ Tooltip
                      {:disableHoverListener (not identifier-overflowing)
                       :title identifier}
                      ($ Typography
                         {:fontWeight "500"
                          :noWrap true
                          :ref identifier-overflowing-ref}
                         identifier)))

                ($ variant-widgets/ad-variant-type-info
                   {:ad-variant variant
                    :sx #js {:fontSize "sm"
                             :color "grey.20"}}))
             (when has-product-placeholders?
               ($ Tooltip
                  {:title "Show products"
                   :placement "bottom"}
                  ($ IconButton
                     {:size "small"
                      :disabled accessed-via-share-link
                      :onClick (fn [e]
                                 (let [product-selector-id (variant-data/get-product-selector-id variant)]
                                   (rf/dispatch [:ocp/open {:id :product-selector/crud
                                                            :props {:product-selector-id product-selector-id
                                                                    :allow-product-overrides? allow-product-overrides?
                                                                    :product-overrides product-overrides
                                                                    :set-products-fn on-product-selected
                                                                    :opened-from-preview-page? true}}])
                                   (.preventDefault e)
                                   (.stopPropagation e)))}
                     ($ Cart)))))

          (when (and user-is-reviewer (not user-is-review-creator) (not accessed-via-share-link))
            ($ :<>
               ($ Button
                  {:variant "outlined"
                   :startIcon ($ Icon "check")
                   :disabled (= variant-qc-status "approved")
                   :onClick (fn [_e]
                              (set-qc-approval {:status "approved"
                                                :ad-variant-uuid uuid}))}
                  "Approve")
               ($ Button
                  {:variant "outlined"
                   :startIcon ($ Icon "clear")
                   :disabled (= variant-qc-status "rejected")
                   :onClick (fn [_e]
                              (set-qc-approval {:status "rejected"
                                                :ad-variant-uuid uuid}
                                               #js {:onSuccess #(trigger-comment-to-variant
                                                                 {:has-video has-video
                                                                  :video-status-ref video-status-ref
                                                                  :ad-variant-uuid uuid
                                                                  :identifier identifier})}))}
                  "Request changes")))))))
